module.exports = __webpack_public_path__ + "static/media/Developmenticon06@3x.9f8191f5.png";